import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { UpdateCartRequest } from 'src/types/cart';
import axiosInstance from 'src/utils/axios';

interface UseUpdateCartMutationOptions {
  onSuccess?: (data: any, request: UpdateCartRequest) => void;
  onError?: (error: any) => void;
}

const useUpdateCartMutation = ({ onSuccess, onError }: UseUpdateCartMutationOptions = {}) => {
  const mutation = useMutation({
    mutationFn: async (request: UpdateCartRequest) => {
      const response = await axiosInstance.post(api.updateCart, request);
      return response.data;
    },
    onSuccess: (data, request) => {
      // to do invalidate product list api query
      onSuccess?.(data, request);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useUpdateCartMutation;
